const AMASYAETGUIDS = ['46d3187d-80aa-e711-80d2-0050568e5e5d', '5edb25cd-05be-e711-9419-0050568045bb'];

export function findIsAmasyaEt(brandId) {
  if (!brandId) return false;
  return AMASYAETGUIDS.includes(brandId);
}
